import { useSupportHelpdeskV2Enabled } from "@redotech/redo-merchant-app-common/setting/use-support-helpdesk-v2-enabled";

/**
 * Merchant-app compatibility wrapper around the shared support-v2 flag hook.
 * Kept so existing support-v2 callers can use the older `{ value }` shape while
 * sharing the team-scoped React Query cache with settings pages.
 */
export interface SupportV2EnabledLoad {
  readonly pending: boolean;
  readonly value: boolean;
}

export function useSupportV2Enabled(): SupportV2EnabledLoad {
  const { pending, enabled } = useSupportHelpdeskV2Enabled();
  return { pending, value: enabled };
}
